module.exports = __webpack_public_path__ + "ENG_SPT2-Kites_225002840-9fa5b1b6066d205a4c87d8fb2e9b3732.png";